import { render, staticRenderFns } from "./DiscontinuedDesign.vue?vue&type=template&id=0155e836&"
import script from "./DiscontinuedDesign.vue?vue&type=script&lang=js&"
export * from "./DiscontinuedDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports